import React from "react";
import { Link } from "react-router-dom";
const SucessStoryPage = () => {
  const blogPost = {
    title: "Master the Art of Proposal Writing",
    subtitle: "This is what it looks like when you don't fold...",
    category: "BUSINESS TIPS",
    publishDate: "April 15, 2025",
    author: {
      name: "Sarah Johnson",
      title: "Senior Proposal Strategist",
      image: "https://randomuser.me/api/portraits/women/42.jpg",
    },
    featuredImage:
      "https://www.uptonbarn.com/wp-content/uploads/2024/07/Lucy-and-Yousef-High-Resolution-832-of-1006-scaled.jpg",
    readTime: "8 min read",
    content: `
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Journey to Proposal Excellence</h2>
      <p>Three rejections. One contract lost. Ten potential clients later, we're still here. Three successful bids. A template we built from scratch — perfected over years of trial and error. This is the story of how we mastered the art of proposal writing and how you can too.</p>
      
      <p>When we first started our business consulting firm in 2015, we thought writing proposals would be the easy part. After all, we had the expertise, the vision, and the passion. What more did we need? As it turns out, quite a lot.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Hard Lessons</h2>
      <p>Our first major proposal was a disaster. We spent weeks crafting what we thought was the perfect pitch for a Fortune 500 client. The proposal was 47 pages long, filled with industry jargon, and focused primarily on our credentials. We didn't get the contract.</p>
      
      <p>Our second and third attempts weren't much better. We made incremental improvements, but we were still missing something crucial. After our third rejection, we decided to take a step back and completely rethink our approach.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Turning Point</h2>
      <p>The breakthrough came when we started thinking about proposals not as documents about us, but as stories about our clients. We began each proposal by articulating the client's challenges in their own language. We showed that we truly understood their pain points before offering our solutions.</p>
      
      <p>We also drastically simplified our format. Instead of long-winded explanations, we used:</p>
      <ul>
        <li>Clear, concise statements of value</li>
        <li>Visual representations of complex concepts</li>
        <li>Specific, measurable outcomes</li>
        <li>Social proof in the form of relevant case studies</li>
      </ul>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Framework That Changed Everything</h2>
      <p>After years of refinement, we developed what we now call the "CLEAR" framework for proposal writing:</p>
      
      <h3 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">C - Client-Centered</h3>
      <p>Every proposal must begin with a deep understanding of the client's needs, goals, and challenges. This isn't just a token gesture; it's the foundation of everything that follows.</p>
      
      <h3 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">L - Logical Flow</h3>
      <p>Information should be presented in a natural progression that leads the client from problem to solution to outcome without requiring them to jump back and forth between sections.</p>
      
      <h3 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">E - Evidence-Based</h3>
      <p>Claims about capabilities and outcomes must be supported by concrete evidence, whether in the form of case studies, testimonials, or data from previous projects.</p>
      
      <h3 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">A - Actionable Next Steps</h3>
      <p>Every proposal should conclude with clear instructions on how to proceed, including timelines, investment requirements, and the specific actions required to move forward.</p>
      
      <h3 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">R - Relevant Differentiation</h3>
      <p>The proposal must clearly articulate why your solution is uniquely suited to address the client's specific needs in ways that competitors cannot match.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Results</h2>
      <p>Since implementing the CLEAR framework, our proposal win rate has increased from less than 20% to over 70%. We've secured contracts with clients we once thought were out of our reach, and we've been able to command premium pricing for our services.</p>
      
      <p>But perhaps most importantly, we've transformed what was once a dreaded task into a strategic advantage. Our proposals are now among our most powerful business development tools.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Your Turn</h2>
      <p>If you're struggling with proposal writing, remember that you're not alone. It's a skill that can be learned and refined over time. Start by focusing on your client's needs rather than your own capabilities. Use clear, simple language. And always, always make it easy for the client to say yes.</p>
      
      <p>In our next article, we'll dive deeper into each element of the CLEAR framework and provide specific examples of how to implement them in your own proposals.</p>
      
      <p>Until then, keep writing, keep learning, and don't fold when faced with rejection. The next great proposal might be the one that changes everything for your business.</p>
    `,
    tags: [
      "Business Development",
      "Proposal Writing",
      "Client Acquisition",
      "Business Strategy",
    ],
    relatedPosts: [
      {
        id: 1,
        title: "Structure Your Proposal Like a Pro: 5 Templates That Convert",
        image:
          "https://plus.unsplash.com/premium_photo-1690148812608-9942834931a1?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8d2VkZGluZ3xlbnwwfHwwfHx8MA%3D%3D",
        category: "BUSINESS STRATEGY",
      },
      {
        id: 2,
        title: "When is the Best Time to Submit Your Proposal in 2025?",
        image:
          "https://i0.wp.com/www.jenniferborisphotographyblog.com/wp-content/uploads/2020/11/townsend-hotel-community-house-birmingham-michigan-wedding-photo-176.jpg?resize=1000%2C667&ssl=1",
        category: "COMMUNITY",
      },
      {
        id: 3,
        title:
          "Did Your Last Proposal Win the Contract? The Inside Scoop of Business Success",
        image:
          "https://plus.unsplash.com/premium_photo-1663076211121-36754a46de8d?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bWFycmlhZ2V8ZW58MHx8MHx8fDA%3D",
        category: "SELECTPROPOSAL",
      },
    ],
  };

  return (
    <div className="font-sans max-w-4xl mx-auto p-4 pb-16">
      {/* Breadcrumb Navigation */}
      <div className="flex items-center text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-pink-500">
          Home
        </Link>
        <span className="mx-2">/</span>
        <Link to="/blogs" className="hover:text-pink-500">
          Blog
        </Link>
        <span className="mx-2">/</span>
        <span className="text-gray-700">{blogPost.title}</span>
      </div>

      <div className="mb-4 text-pink-500 font-bold">{blogPost.category}</div>
      <h1 className="text-4xl font-serif font-bold mb-2">{blogPost.title}</h1>
      <h2 className="text-2xl font-serif text-gray-600 mb-6">
        {blogPost.subtitle}
      </h2>

      {/* Article Meta */}
      <div className="flex items-center justify-between mb-8 border-b border-gray-200 pb-4">
        <div className="flex items-center">
          <img
            src={blogPost.author.image}
            alt={blogPost.author.name}
            className="w-12 h-12 rounded-full mr-4 hover:scale-105 transition-transform duration-300"
          />
          <div>
            <div className="font-medium">{blogPost.author.name}</div>
            <div className="text-sm text-gray-500">{blogPost.author.title}</div>
          </div>
        </div>
        <div className="text-sm text-gray-500">
          <span>{blogPost.publishDate}</span>
          <span className="mx-2">•</span>
          <span>{blogPost.readTime}</span>
        </div>
      </div>

      {/* Featured Image */}
      <div className="mb-8">
        <img
          src={blogPost.featuredImage}
          alt={blogPost.title}
          className="w-full h-auto rounded-lg shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Article Content */}
      <div
        className="prose prose-lg max-w-none mb-12"
        dangerouslySetInnerHTML={{ __html: blogPost.content }}
      />

      {/* Tags */}
      <div className="mb-12">
        <h3 className="text-lg font-serif font-bold mb-4 text-pink-500">
          Related Topics
        </h3>
        <div className="flex flex-wrap gap-2">
          {blogPost.tags.map((tag, index) => (
            <span
              key={index}
              // href={`/tags/${tag.toLowerCase().replace(/\s+/g, "-")}`}
              className="cursor-default bg-gray-100 hover:bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Author Box */}
      <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-12">
        <div className="flex items-start">
          <img
            src={blogPost.author.image}
            alt={blogPost.author.name}
            className="w-16 h-16 rounded-full mr-6 hover:scale-105 transition-transform duration-300"
          />
          <div>
            <h3 className="font-bold font-serif text-lg  mb-2">
              About {blogPost.author.name}
            </h3>
            <p className="text-gray-700 mb-4">
              Sarah Johnson is a Senior Proposal Strategist with over 15 years
              of experience in business development. She has helped companies
              secure over $500 million in contracts through effective proposal
              strategies.
            </p>
            <div className="flex gap-4">
              <Link
                to="/blogs/success-story"
                className="text-pink-500 hover:text-pink-700"
              >
                Read articles by this author
              </Link>
              <Link
                to="/blogs/success-story"
                className="text-pink-500 hover:text-pink-700"
              >
                Follow on LinkedIn
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Related Posts */}
      <div>
        <h3 className="text-2xl font-serif font-bold mb-6 cursor-default text-pink-500">
          Related Articles
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {blogPost.relatedPosts.map((post) => (
            // <a key={post.id} href={`/blog/${post.id}`} className="group">
            <div
              key={post.id}
              className="border-b-4 border-red-600 rounded-bl-md rounded-br-md"
            >
              <div className="mb-3">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48  object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="mb-1 text-pink-500 font-bold text-sm cursor-default">
                {post.category}
              </div>
              <h4 className="text-lg font-serif font-bold hover:text-[#730000] cursor-default">
                {post.title}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SucessStoryPage;
